// extracted by mini-css-extract-plugin
module.exports = {"label":"WCSTextInput_label__1FGyT","inputDefault":"WCSTextInput_inputDefault__3UC9b","errorInput":"WCSTextInput_errorInput__2PtBi"};